"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const fi_1 = require("react-icons/fi");
function MenuAdmin() {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("input", { type: "checkbox", name: "nav", id: "nav_button" }),
        react_1.default.createElement("label", { htmlFor: "nav_button", className: "on no-view-mobile", style: { cursor: "pointer" } },
            react_1.default.createElement(fi_1.FiMenu, { className: "icon-side-menu" }))));
}
exports.default = MenuAdmin;
